
<div class="form-container" [style]="{width: width, boxShadow: boxShadow}">
    <h5 class="text-center fw-bold mt-3 mb-3 heading">Organization Details</h5>
    <!-- <h5 class="text-center mt-3 mb-3" *ngIf="!isNewUserRegistration; else organizationDetailsHeading">Organization Details</h5>
    <ng-template #organizationDetailsHeading>
        <h5 class="text-center fw-bold mt-3 mb-3 heading">Organization Details</h5>
    </ng-template> -->
    <dx-form [formData]="organization">
        <dxi-item 
            dataField="organisationName"
            [editorOptions]="{
                placeholder: '',
                labelMode: 'floating',
            }">
            <dxo-label
                [visible]="false">
            </dxo-label>
            <dxi-validation-rule 
                type="required" 
                message="Organization name is required">
            </dxi-validation-rule>
        </dxi-item>

        <dxi-item 
            dataField="companyRegistrationNumber"
            [editorOptions]="{
                placeholder: '',
                labelMode: 'floating',
            }">
            <dxo-label
                [visible]="false">
            </dxo-label>
            <dxi-validation-rule 
                type="required" 
                message="Company Registration Number is required">
            </dxi-validation-rule>            
        </dxi-item>

        <dxi-item
            dataField="address"
            editorType="dxTextBox"
            [editorOptions]="{
                placeholder: '',
                labelMode: 'floating', 
            }">
            <dxo-label
                [visible]="false">
            </dxo-label>
            <dxi-validation-rule 
                type="required" 
                message="Address is required">
            </dxi-validation-rule>    
        </dxi-item>

        <dxi-item 
            dataField="city"
            [editorOptions]="{
                placeholder: '',
                labelMode: 'floating',
            }">
            <dxo-label
                [visible]="false">
            </dxo-label>
            <dxi-validation-rule 
                type="required" 
                message="City is required">
            </dxi-validation-rule>    
        </dxi-item>

        <dxi-item 
            dataField="zip"
            [editorOptions]="{
                placeholder: '',
                labelMode: 'floating',
            }">
            <dxo-label
                [visible]="false">
            </dxo-label>
            <dxi-validation-rule 
                type="required" 
                message="Zipcode is required">
            </dxi-validation-rule>    
        </dxi-item>

        <dxi-item>
            <div *dxTemplate>
                <dx-select-box
                    required
                    [(value)]="organization.country"
                    [dataSource]="countriesList"
                    [searchEnabled]="true"
                    keyExpr="name"
                    valueExpr="name"
                    displayExpr="name"
                    placeholder="Country"
                    [elementAttr]="{class: 'custom-select-box'}"
                    label="Country"
                    labelMode="floating"    
                ></dx-select-box>
            </div>
            <dxo-label
                [visible]="false">
            </dxo-label>
            <dxi-validation-rule 
                type="required" 
                message="Country is required">
            </dxi-validation-rule>    
        </dxi-item>
        <!-- <dxi-item *ngIf="!isNewUserRegistration">
            <div *dxTemplate>
                <dx-select-box
                    [items]="countryCurrency"
                    displayExpr="displayExpr"
                    valueExpr="currency"
                    label="Currency"
                    labelMode="floating"
                    placeholder="Currency"
                    [elementAttr]="{class: 'custom-select-box'}"
                    [(value)]="organization.currency"
                >
                </dx-select-box>
            </div>
            <dxo-label
                [visible]="false">
            </dxo-label>
            <dxi-validation-rule 
                type="required" 
                message="Currency is required">
            </dxi-validation-rule> 
        </dxi-item> -->
        <dxi-item 
            dataField="contactPerson"
            [editorOptions]="{
                labelMode: 'floating',
            }">
            <dxo-label
                [visible]="false">
            </dxo-label>
            <dxi-validation-rule 
                type="required" 
                message="">
            </dxi-validation-rule>    
        </dxi-item>

        <dxi-item 
            dataField="email"
            [editorOptions]="{
                mode: 'email',
                labelMode: 'floating',
                }">
            <dxo-label
                [visible]="false">
            </dxo-label>
            <dxi-validation-rule 
                type="required" 
                message="">
            </dxi-validation-rule> 
            <dxi-validation-rule 
                type="email" 
                message="Enter a valid email address">
            </dxi-validation-rule>
        </dxi-item>

        <dxi-item
            itemType="group"
            [colCount]="2">
            <dxo-col-count-by-screen
                [xs]="1"
                [sm]="2">
            </dxo-col-count-by-screen>

            <dxi-item 
                dataField="countryCode"
                editorType="dxSelectBox"
                [editorOptions]="countryCodeOptions">
                <dxo-label
                    [visible]="false">
                </dxo-label>
                <dxi-validation-rule 
                    type="required" 
                    message="">
                </dxi-validation-rule> 
            </dxi-item>

            <dxi-item 
                dataField="contactNumber"
                [editorOptions]="{
                    labelMode: 'floating',
                }">
                <dxo-label
                    [visible]="false">
                </dxo-label>
                <dxi-validation-rule 
                    type="required" 
                    message="">
                </dxi-validation-rule>
                <dxi-validation-rule 
                    type="pattern" 
                    [pattern]="'^[0-9]{7,15}$'" 
                    message="Please enter a valid phone number">
                </dxi-validation-rule>
            </dxi-item>
            
        </dxi-item>
    </dx-form>

    <!-- <div class="d-flex flex-row justify-content-center justify-content-sm-end align-items-center mt-3" *ngIf="!isNewUserRegistration">
        <dx-button
            text="Next"
            icon="arrowright"
            [elementAttr]="{class: 'next-button'}"
            [rtlEnabled]="true"
            (onClick)="nextButtonClicked()">
        </dx-button>
    </div> -->

    <div class="d-flex flex-row justify-content-between align-items-center mt-3" *ngIf="isNewUserRegistration || true">
        <dx-button
            text="Back"
            icon="arrowleft"
            type="normal"
            (onClick)="goBack.emit(organization)">
        </dx-button>

        <dx-button
            text="Next"
            icon="arrowright"
            [elementAttr]="{class: 'next-button'}"
            [rtlEnabled]="true"
            (onClick)="nextButtonClicked()">
        </dx-button>
    </div>

</div>